import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const payment = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const refund = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/refund'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const createPaypalOrder = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/create-paypal-order'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const paypalOrderApproval = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/paypal-order-approval'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const cardCredit = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/card-credit'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const cardIntegrated = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/card-integrated'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const cancelCardOrder = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/cancel-card-order'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const paymentApi = {
	payment,
	refund,
	createPaypalOrder,
	paypalOrderApproval,
	cardCredit,
	cardIntegrated,
	cancelCardOrder,
}

export default paymentApi
